type CheckmarkIconProps = {
  color: string;
  size?: string;
};

export const CheckmarkIcon = ({ color, size = "28" }: CheckmarkIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 28 28"
  >
    <g data-name="Layer 2">
      <g data-name="invisible box">
        <path data-name="Rectangle 6239" fill="none" d="M0 0h28v28H0z" />
      </g>
      <g data-name="icons Q2">
        <path
          data-name="Tracé 11398"
          d="m10.645 25.8-4.786-4.509a1.178 1.178 0 1 1 1.675-1.656l3.948 3.765L25.6 9.928a1.239 1.239 0 0 1 1.564.106 1.1 1.1 0 0 1 .111 1.493L12.32 25.8a1.174 1.174 0 0 1-1.675 0z"
          transform="translate(-2.36 -4.083)"
          fill={color}
        />
      </g>
    </g>
  </svg>
);
